import React from 'react'
import SVGInline from 'react-svg-inline'
import PropTypes from 'prop-types'
import checkboxUnchecked from '../../../../images/checkbox-unchecked.svg'
import checkboxChecked from '../../../../images/checkbox-checked.svg'
import chevronRight from '../../../../images/chevron-right.svg'
import eyeClose from '../../../../images/eye-close.svg'
import lock from '../../../../images/lock.svg'
import refresh from '../../../../images/refresh.svg'
import copy from '../../../../images/copy.svg'
import okShield from '../../../../images/ok-shield.svg'
import flagShield from '../../../../images/flag-shield.svg'
import info from '../../../../images/info.svg'

const iconMap = {
    checkboxChecked,
    checkboxUnchecked,
    chevronRight,
    eyeClose,
    lock,
    refresh,
    copy,
    okShield,
    flagShield,
    info,
}

const SVG = ({icon, color, ...props}) => {
    return (
        <SVGInline svg={iconMap[icon]} style={{color: color}} {...props}/>
    )
}

SVG.propTypes = {
    icon: PropTypes.string.isRequired,
    color: PropTypes.string,
}

export default SVG



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Atoms/SVG.jsx